import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { userFormSkeletonClasses, UserFormStyledGrid } from './UserFormSkeleton.styles';



const UserFormSkeleton = () => (
  <UserFormStyledGrid container spacing={2}>
    <Grid item md={6} sm={12}>
      <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.input} />
      <br />
      <Grid container spacing={4}>
        <Grid item md={6}>
          <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.input} />
        </Grid>
        <Grid item md={6}>
          <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.input} />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item md={6}>
          <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.input} />
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <Grid container spacing={2}>
        <Grid item md={12}>
          <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.media} />
        </Grid>
      </Grid>
    </Grid>
    <Grid item md={6} sm={12}>
      <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.input} />
      <br />
      <Skeleton animation="wave" variant="rect" className={userFormSkeletonClasses.media} />
    </Grid>
  </UserFormStyledGrid>
);

export default UserFormSkeleton;
